import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { toast } from "react-toastify";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {
  addFavourite,
  removeFavourite,
} from "../../Components/redux/favouritesSlice";
import { useNavigate } from 'react-router-dom';

function PaginatedItems({ itemsPerPage, items }) {


  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const navigate = useNavigate();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  
    const dispatch = useDispatch();
    const favourites = useSelector((state) => state.favourites.items);
  

const userId = useSelector((state) => state.user.id);
  
    useEffect(() => {
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(items.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);
  
  
    const isFavourite = (id) => favourites.includes(Number(id));
  
    const toggleFavourite = async (productId) => {
          // Kullanıcı giriş yapmamışsa uyarı göster ve devam etme
        if (!userId) {
          navigate(`/${currentLanguage}/login`);
          toast.error(t("Zəhmət olmasa giriş edin"));
          return;
        }
      
        if (!productId) return;
  
      try {
        if (isFavourite(productId)) {
          dispatch(removeFavourite(productId));
          await axios.delete("https://www.elzabeauty.az/elza/favourites.php", {
            data: new URLSearchParams({
              user_id: userId,
              product_id: productId,
            }),
          });
          toast.error(t("Sevimlilərdən çıxarıldı"));
        } else {
          dispatch(addFavourite(productId));
          await axios.post(
            "https://www.elzabeauty.az/elza/favourites.php",
            new URLSearchParams({ user_id: userId, product_id: productId })
          );
          toast.success(t("Sevimlilərə əlavə olundu"));
        }
      } catch (error) {
        console.error("Favori güncelleme hatası:", error);
      }
    };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  const getLocalizedValue = (base, baseEn, baseRu) => {
    if (currentLanguage === 'en') return baseEn;
    if (currentLanguage === 'ru') return baseRu;
    return base;
  };

  return (
    <>
      <div className='max-w-container mx-auto grid grid-cols-1 md:grid-cols-4 gap-4'>
        {currentItems.map((item, index) => {
 
          return (
              <a href={`/${currentLanguage}/product-detail/${item.id}`}>
      <div className='bg-white rounded-[8px] w-full md:w-[289px] min-h-[330px] mx-auto p-5 shadow-md group relative'>
        {(item.isNew === 1 || item.isBestseller === 1 || item.discount > 0) && (
  <div className="absolute top-3 left-3 bg-[#E497BB] text-[white] text-[14px] font-medium px-2 py-1 rounded z-10">
    {item.isNew === 1
      ? t("Yeni")
      : item.isBestseller === 1
      ? t("Ən çox satılanlar")
      : item.discount > 0
      ? `- ${item.discount} %`
      : null}
  </div>
  
)}

 <div className="absolute top-0 right-0 z-10">
              <div
  onClick={(e) => {
    e.preventDefault();
    toggleFavourite(item.id);
  }}
  role="button"
  tabIndex={0}
  aria-label={
    isFavourite(item.id)
      ? t("Favorilerden çıkar")
      : t("Favorilere ekle")
  }
  className="absolute top-3 right-3 z-10 text-[24px] cursor-pointer select-none"
   style={{ color: isFavourite(item.id) ? 'red' : 'gray' }}
>
  {isFavourite(item.id) ? '❤️' : '🤍'}
</div>
 
              </div>
        <div className='text-[#0B0B0B]'>
          <div className='bg-white h-[224px] flex justify-center items-center relative overflow-hidden'>
            <img
              className='w-full h-full transition-all duration-300 group-hover:scale-110 object-cover'
              src={`https://www.elzabeauty.az/elza/${item.image1}`}
              alt={item.name || 'Product image'}
            />
          </div>
          <p className='font-medium mt-5 text-[#121212]'>
            {getLocalizedValue(item.name, item.nameEn, item.nameRu)}
          </p>

          {/* Renk kutuları */}
         <div className="flex gap-2 mt-3">
           {item.colors?.map((colorItem, index) => (
  <div
    key={index}
    className="w-7 h-7 flex items-center justify-center rounded-full border border-[#838383] bg-white"
    title={colorItem.name}
  >
    <div
      className="w-5 h-5 rounded-full"
      style={{ backgroundColor: colorItem.code }}
    ></div>
  </div>
))}

          </div>
        </div>
      </div>
    </a>
          );
        })}
      </div>

      <ReactPaginate
        nextLabel={t("sonrakı")}
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLabel={t("əvvəlki")}
        renderOnZeroPageCount={null}
        containerClassName="flex justify-center items-center space-x-1 my-4"
        pageClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        previousClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        nextClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        activeClassName="bg-blue-600 text-white"
        disabledClassName="text-gray-400 cursor-not-allowed"
      />
    </>
  );
}

export default PaginatedItems;
